export default __webpack_public_path__ + "static/logo_icon-aedff8f1978d95030d61b0f7e57de5d9.svg";